export default __webpack_public_path__ + "static/media/11.0b518f86.jpg";